import * as React from "react";

const QUERY = "(prefers-reduced-motion: reduce)";

// True when the OS asks for reduced motion; follows the setting live.
export function usePrefersReducedMotion() {
  const [prefersReducedMotion, setPrefersReducedMotion] = React.useState(
    () => typeof window !== "undefined" && Boolean(window.matchMedia?.(QUERY).matches)
  );

  React.useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return undefined;
    const mql = window.matchMedia(QUERY);
    const onChange = () => setPrefersReducedMotion(mql.matches);
    onChange();
    mql.addEventListener?.("change", onChange);
    return () => mql.removeEventListener?.("change", onChange);
  }, []);

  return prefersReducedMotion;
}
